import React, { createRef, useState, useEffect, useCallback } from 'react';

import { toast } from 'react-toastify';

import { isNull, isArray, isEmpty, isUndefined } from 'lodash';

import { Autocomplete } from '@material-ui/lab';

import { Tabela, Bicos } from './components'

import CardGrid from './components/CardGrid';

import { TextField } from '@material-ui/core';

import qs from 'querystring';

import moment from 'moment';

import { t } from '~/helpers';

import api from '~/services/api';


import * as S from './styles';

export default function OperacaoDiagnostico() {

	const [load, setLoad] = React.useState(false);

	const [terminais, setTerminais] = React.useState([]);

	const [bicos, setBicos] = React.useState([]);

	const [tanks, setTanks] = React.useState([]);

	const [posto, setPosto] = useState(0);
	const [combo, setCombo] = useState([]);


	const [terminalSelecionado, setTerminalSelecionado] = useState({});

	const [mostraBicos, setMostraBicos] = React.useState(false);


	async function handleBicos(values) {

		setTerminalSelecionado((oldVal) => {
			if (oldVal == values) {
				setMostraBicos((state) => !state)
			} else {
				setMostraBicos(true)
			}
			return values
		});

	}



	async function handleUsuariosEnvio(values) {


		try {
			const term_identificacao = values.term_identificacao;
			await api.put('terminal/gerafrentistas', term_identificacao);
			toast.success(`Os usuários serão encaminhado para o ${values.term_identificacao}`);
		} catch (err) {
			if (isArray(err)) {
				err.map((e) => toast.error(e));
			}
			//const validationErrors = {};
		}
	}

	async function handleTogglePostoComboio() {
		const { data } = await api.get('postosporusuario', {
			params: { pagesize: 99999 },
		});

		await setCombo(data.items);
	}

	// Stock column heads
	const cellTerminal = React.useMemo(
		() => [
			{
				id: 'term_identificacao',
				label: "Terminal",
			},
			{
				id: 'framesValidos',
				label: "Frames OK"
			},
			{
				id: 'framesComErro',
				label: "Frames Error",
				align: 'right',
			},

			{
				id: 'bicoAbastecendo',
				label: "Bico Abastecendo",
				align: 'right',
			},

			{
				id: 'bicoVazamento',
				label: "Bico Vazamento",
				align: 'right',
			},


			{
				id: 'regsPendentes',
				label: "Regs. Pendentes",
				align: 'right',
			},

			{
				id: 'term_estado',
				label: "Estado",
				align: 'right',
			},

			{
				id: 'UltimaConexao',
				label: "Última AT",
				align: 'right',
			},
		],
		[t]
	);

	// Stock column heads
	const cellBicos = React.useMemo(
		() => [
			// {
			// 	id: 'idTerminal',
			// 	label: "Terminal",
			// },
			{
				id: 'codigoBico',
				label: "Bico",
				align: 'right',
			},
			{
				id: 'codigoFrota',
				label: "Frota",
				align: 'right',
			},

			{
				id: 'litros',
				label: "Litros",
				align: 'right',
			},

			{
				id: 'bicoAbastecendo',
				label: "Bico Abastecendo",
				align: 'right',
			},

			{
				id: 'bicoVazamento',
				label: "Bico Vazamento",
				align: 'right',
			},

			// {
			// 	id: 'UltimaConexao',
			// 	label: "Última AT",
			// 	align: 'right',
			// },
		],
		[t]
	);



	// Initial data
	React.useEffect(() => {
		handleGetTanks();
	}, []);

	// Load tanks
	const handleGetTanks = React.useCallback(async () => {
		const params = { pagesize: 9999 };
		setLoad(true);
		try {
			const { data } = await api.get('postosporusuario', { params });
			setTanks(data.items);
		} catch (err) {
			if (isArray(err)) err.map((e) => toast.error(t(e)));
			else toast.error(t(err));
		} finally {
			setLoad(false);
		}
	}, []);

	async function handleToggleCombo(value) {
		await setPosto(false);

		if (!isEmpty(value.combo)) {
			await setPosto(value.combo.poco_codigo);
		}
	}

	useEffect(() => {
		handleTogglePostoComboio();
	}, []);


	// Change autocomplete
	const handleChangeAutocomplete = React.useCallback(
		(value) => {
			if (isNull(value)) {
				handleResetVars();
			} else {
				const { poco_codigo } = value;
				setPosto(poco_codigo);
				handleGetDataTable(poco_codigo);

				setMostraBicos(false);
				setTerminalSelecionado({});

			}
		},
		[posto]
	);

	// Loading data to fill the tables
	const handleGetDataTable = React.useCallback(async (id, temporizador = 0) => {
		const params = {
			wherefield: ['poco_codigo'],
			typewherefield: ['EQUALS'],
			valuewherefield: [id],
			orderfield: 'term_identificacao',
			pagesize: 99999,
			temporizador: temporizador

		};
		try {
			const { data } = await api.get('terminal/retornaterminalposto',
				{
					params,
					paramsSerializer: (param) => qs.stringify(param)
				});

			const objs =
				data.items.map((item) => ({
					...item,
					...item.StatusTerminal[0],
					UltimaConexao: moment(item.StatusTerminal[0].UltimaConexao).format('DD/MM/YYYY HH:mm:ss')
				}))

			setTerminais(
				objs
			);

			/*

			const objsBicos =
				data.items.map((item) => ({
					...item,						
				}))

			setBicos(
				objsBicos
			);
			*/


		} catch (err) {
			if (isArray(err)) err.map((e) => toast.error(t(e)));
			else toast.error(t(err));
			handleResetVars();
		}
	}, []);


	// Filtra bicos selecionado
	React.useEffect(() => {

		if (mostraBicos) {

			const lBicos = [];

			let idTerminal = terminalSelecionado.term_identificacao;

			for (var i = 0; i < terminais.length; i++) {

				const term = terminais[i];

				if (term.term_identificacao === idTerminal) {

					if (!isUndefined(terminais[i].statusBicoTerminal)) {

						for (var b = 0; b < terminais[i].statusBicoTerminal.length; b++) {
							const bic = terminais[i].statusBicoTerminal[b];

							bic.UltimaConexao = moment(terminais[i].statusBicoTerminal[b].UltimaConexao).format('DD/MM/YYYY HH:mm:ss')

							lBicos.push({ ...bic, terminal_estado: term.term_estado });
						}
					}

				}

				//if ( terminais.indexOf( terminais[ i ] ) === i ) {
				//	lBicos.push(terminais[ i ] );
				//}

			}

			setBicos(
				lBicos
			);


		}

	}, [terminais, mostraBicos, terminalSelecionado]);



	// Autoload
	React.useEffect(() => {
		if (posto !== 0) {
			const timeOut = setInterval(() => {
				handleGetDataTable(posto, 1);
			}, 30000);

			return () => clearInterval(timeOut);
		}
	}, [posto, terminais]);



	// Reset vars
	const handleResetVars = React.useCallback(() => {
		setTerminais([]);
		setPosto(0);
		setMostraBicos(false);
		setTerminalSelecionado({});

	}, []);

	return (

		<S.Wrapper>
			<S.WrapperGroupText>
				<S.WrapperHeader>

					<Autocomplete
						options={tanks}
						getOptionLabel={({ poco_descricao }) => poco_descricao}
						style={{ width: 300 }}
						onChange={(e, value) => handleChangeAutocomplete(value)}
						renderInput={(params) => (
							<TextField
								{...params}
								label="Posto"
								variant="outlined"
								size="small"
							/>
						)}
					/>

					{/* <Typography>{textView}</Typography> */}
				</S.WrapperHeader>
			</S.WrapperGroupText>
			<S.WrapperGrid>
				<Tabela
					title="Terminais"
					cells={cellTerminal}
					data={terminais}
					size="small"
					onCallback={handleUsuariosEnvio}
					onCallbackBico={handleBicos}
				/>
			</S.WrapperGrid>

			{mostraBicos &&


				<S.WrapperBicos>
					<CardGrid
						term={terminalSelecionado.term_descricao}
						data={bicos}
					/>

				</S.WrapperBicos>
			}


		</S.Wrapper>
	);

}
